import { isPlatformBrowser } from '@angular/common';
import { combineLatest } from 'rxjs';
import { Component, ChangeDetectorRef, PLATFORM_ID, Inject, ElementRef, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { IngredientService } from '@app/services/ingredient/ingredient.service';
import { MenuService } from '@app/services/menu/menu.service';
import { ProductService } from '@app/services/product/product.service';
import { OrdersService } from '@app/services/order/orders.service';
import { Subject } from 'rxjs';
import { OptionsSuppComponent } from '../options-supp/options-supp.component';
import { PersonalizeProductComponent } from '../personalize-product/personalize-product.component';


@Component({
    moduleId: module.id,
    selector: 'menu-modal',
    templateUrl: 'menu-modal.component.html',
    styleUrls: ['menu-modal.component.scss'],
    providers: [MenuService, IngredientService, ProductService]
})
export class MenuModalComponent {
    menu: any = {};
    menuCategory: string = "";
    modalRef: BsModalRef;
    modalRef2: BsModalRef;
    modalRef3: BsModalRef;
    config = {
        ignoreBackdropClick: true
    };
    subscriptions: Subscription[] = [];
    subscriptions2: Subscription[] = [];
    host = "";
    enableAddButton = true;
    goToNext: Subject<number> = new Subject<number>();
    chosenOrderType;
    activeF = 0;
    loader = true;
    orderProg;
    @ViewChild('scrollTap') scrollTap: ElementRef
    constructor(
        public bsModalRef: BsModalRef,
        private modalService: BsModalService,
        private menuService: MenuService,
        private changeDetection: ChangeDetectorRef,
        private orderService: OrdersService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        const subs1 = this.orderService.chosenOrderType.subscribe((chosenOrderType: number) => {
            this.chosenOrderType = chosenOrderType;
        });
        const subs2 = this.orderService.orderProg.subscribe(orderProg => {
            this.orderProg = orderProg;
        });
        this.subscriptions2.push(subs1,subs2)
    }
    PersonalizeModal(product, next) {
        if (product.available && (product.compositions.length > 0 || product.maxNbrIngOptions > 0 || product.hasSupp)) {
            const _combine = combineLatest(
                this.modalService.onHidden
            ).subscribe(() => this.changeDetection.markForCheck());
            this.subscriptions.push(
                this.modalService.onHidden.subscribe((data: any) => {
                    if (data && next) {
                        this.next();
                    }
                    this.unsubscribe();
                })
            );
            this.subscriptions.push(_combine);
            this.modalRef2 = this.modalService.show(PersonalizeProductComponent, { class: 'modal-content3' });
            this.modalRef2.content.product = product;
            this.modalRef2.content.ismenuproduct=true
        }
    }
    AddOptionsSupp(options) {
        const initialState = {
            keyboard: false,
            backdrop: false,
            ignoreBackdropClick: true,
            class: 'modal-content-options'
        };
        const _combine = combineLatest(
            this.modalService.onHidden
        ).subscribe(() => this.changeDetection.markForCheck());
        this.subscriptions.push(
            this.modalService.onHidden.subscribe((data: any) => {
                    this.orderService.addMenu(this.menu).then(
                        (d) => {
                            this.bsModalRef.hide();
                        }, (err) => {
                            console.log(err);
                        }
                    )
                this.unsubscribe();
            })
        );
        this.subscriptions.push(_combine);
        this.modalRef3 = this.modalService.show(OptionsSuppComponent, initialState);
        this.modalRef3.content.options = options;

    }

    ngOnInit() {
        
        setTimeout(
            () => {
                this.menu.choix = [
                    { checked: false },
                    { checked: false },
                    { checked: false },
                    { checked: false },
                    { checked: false },
                    { checked: false },
                    { checked: false },
                ]
                this.menu.additionalOptions = [];
                this.menu.compositions2 = [];
                this.menuService.getMenuCompositions(this.menu.id, this.chosenOrderType,this.orderProg).subscribe(
                    (data: any) => {
                        this.loader = false;
                        this.menu.compositions2 = data;
                        this.menu.compositions2.forEach((compsition, ind) => {
                            if (ind > 0 && compsition.length > 0) {
                                compsition.checked = 0;
                            }
                            compsition.forEach(comp => {
                                if (comp.type == 2) {
                                    comp.elements.forEach((element, l) => {
                                        element.selectedElement = element.findIndex(e => e.available);
                                    });
                                }
                            });
                        });
                    }
                )
                this.menuService.getMenuAdditionalOptionss(this.menu.id).subscribe(
                    (data: any) => {
                        this.loader = false;
                        this.menu.additionalOptions = data.map(
                            addOpt => {
                                addOpt.text = addOpt.name + " ( " + addOpt.size + " " + addOpt.price + "€ )";
                                addOpt.disabled = (addOpt.available) ? false : true;
                                return addOpt;
                            }
                        )
                    }
                )
            }, 100
        )
    }
    setFamily(j, i) {
        this.menu.families[i].checked = j;
        this.activeF = j;
    }
    addToBasket() {
        if (this.menu.additionalOptions.length > 0) {
            this.AddOptionsSupp(this.menu.additionalOptions);
        } else {
            this.orderService.addMenu(this.menu).then(
                (d) => {
                    this.bsModalRef.hide();
                }, (err) => {
                    console.log(err);
                }
            )
        }
    }
    next() {
        this.goToNext.next();
    }
    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }

    unsubscribe2() {
        this.subscriptions2.forEach((subscription2: Subscription) => {
            subscription2.unsubscribe();
        });
        this.subscriptions2 = [];
    }

    ngOnDestroy(){
        this.unsubscribe2();
    }

    change(event) {
        this.enableAddButton = event;
    }


    offset(obj) {
        var rect = obj.getBoundingClientRect();
        var win = obj.ownerDocument.defaultView;
        return {
            top: rect.top + win.pageYOffset
        };
    }

    setActiveTAb() {
        if (isPlatformBrowser(this.platformId)) {
            var outerContent = this.scrollTap.nativeElement;
            var innerContent = <HTMLElement>document.getElementsByClassName('active')[0];
            if (innerContent) {
                const pos = (outerContent.offsetWidth - innerContent.offsetWidth) / 2;
                outerContent.scroll({ left: this.absoluteOffset(innerContent) - pos, top: 0, behavior: 'smooth' });
            }
        }
    }
    absoluteOffset(elem) {
        return elem.offsetParent && elem.offsetLeft + this.absoluteOffset(elem.offsetParent);
    }

    ngAfterViewInit() {
        let content = document.getElementById('personnalisemenu');
        let titles = document.getElementsByClassName('titlemenu');
        setTimeout(
            () => {
                let initoffset = Array.from(titles).map((title,i) => {
                    var rect = title.getBoundingClientRect();
                    var win = title.ownerDocument.defaultView;
                    return rect.top + win.pageYOffset-i*46
                });
                content.addEventListener('scroll', (event) => {
                    Array.from(titles).forEach((title, index) => {
                        let offset = initoffset[index];
                        var scrollTop = content.scrollTop;
                        if (scrollTop > offset) {
                            title.classList.add('fixed');
                        } else {
                            title.classList.remove('fixed');
                        }
                    });
                });
            }, 1000
        )
    }
}